import {
  ApolloClient,
  InMemoryCache /*, defaultDataIdFromObject*/,
  HttpLink,
  // RestLink,
  ApolloLink,
  makeVar,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { RestLink } from "apollo-link-rest";
import { setContext } from "@apollo/client/link/context";

import { parseUrl, stringifyUrl } from "query-string";

import { AUTH_TOKEN, SERVER_API_URL, SERVER_URI } from "./constants";

import moment from "moment"; // TODO remove

import localOptionsQuery from "./components/livedata/local-options-query";

// import { monthVar, trendDurationVar, yearVar } from "./reactive-variables";

// TODO https://www.apollographql.com/docs/react/advanced/boost-migration.html
// https://www.apollographql.com/docs/react/essentials/local-state#code-splitting

export const darkModeVar = makeVar<boolean>(false);

// TODO remove this (and create generators)!

const lastTimeRange = localStorage?.getItem("lastTimeRange") || "P1D";
// const lastTimeRange = "P1D";
const lastPanelId = localStorage?.getItem("lastPanelId") || 0;
const duration = moment.duration(lastTimeRange);
const endDate = moment().endOf(lastTimeRange.endsWith("H") ? "hour" : "day");
const startDate = moment(endDate)
  .subtract(duration)
  .add(1, "second")
  .startOf(lastTimeRange.endsWith("H") ? "hour" : "day");
// LiveData params
const searchParams = new URLSearchParams(window.location.search);
const localeLanguage = searchParams.get("locale");
const unitSystem = searchParams.get("units");
// const trendDuration = searchParams.get("trendduration");
// const month = searchParams.get("month");
// const year = searchParams.get("year");

export const durationSelectVar = makeVar({
  // __typename: "DurationSelect",
  startDateTouched: false,
  startDate: startDate.toJSON(),
  endDate: endDate.toJSON(),
  durationISO: lastTimeRange,
  duration: duration.toISOString(),
});
export const panelSelectVar = makeVar({
  // __typename: "PanelSelect",
  panelId: lastPanelId,
});
export const optionsVar = makeVar({
  // __typename: "LiveDataLocalOptions",
  localeLanguage: localeLanguage || "", // TODO
  unitSystem: unitSystem || "", // TODO
  timeZone: "", // TODO
  // trendDuration: trendDurationVar() || "", // TODO
  // month: monthVar() || "", // TODO
  // year: yearVar() || "", // TODO
});

const cache = new InMemoryCache({
  // See https://www.apollographql.com/docs/react/caching/cache-configuration/#custom-identifiers
  // TODO typePolicies in apollo 3: https://blog.apollographql.com/previewing-the-apollo-client-3-cache-565fadd6a01e
  // dataIdFromObject: (object: any) => {
  //   switch (object.__typename) {
  //     case 'AllData': return object.tagId;
  //     case 'Band': return JSON.stringify(object);
  //     case 'Yaxes': return JSON.stringify(object);
  //     default: return defaultDataIdFromObject(object); // fall back to default handling
  //   }
  // }
  typePolicies: {
    Query: {
      fields: {
        darkMode: {
          read() {
            return darkModeVar();
          },
        },
        durationSelect: {
          read() {
            return durationSelectVar();
          },
        },
        panelSelect: {
          read() {
            return panelSelectVar();
          },
        },
        options: {
          read() {
            return optionsVar();
          },
        },
      },
    },
  },
});

const credentials =
  SERVER_URI === `${window.location.protocol}//${window.location.host}`
    ? "same-origin"
    : "include";

// const SETTINGS = gql`
//     query settings {
//       language @client
//       unitSystem @client
//     }
//   `;

const restLink = new RestLink({
  uri: `${SERVER_API_URL}/`,
  credentials,
  customFetch: (request: RequestInfo, init: RequestInit) => {
    // console.log("customFetch", request, init);
    if (
      typeof request === "string" &&
      (request as string).includes("/livedata/")
    ) {
      // TODO if request/u.url includes("/livedata") ... else return normal fetch
      const u = parseUrl(request as string); // TODO
      // const { data } = client.query(SETTINGS);
      // const local = client.readQuery();
      const local = cache.readQuery<any>({ query: localOptionsQuery });
      // console.log("localoptions", local);
      const {
        localeLanguage,
        unitSystem,
        /*timeZone,*/
        // trendDuration,
        // month,
        // year,
      } = local.options;
      const newQuery = { ...u.query };
      if (localeLanguage) {
        newQuery.locale = localeLanguage;
      }
      if (unitSystem) {
        newQuery.units = unitSystem;
      }
      // if (trendDurationVar()) {
      //   newQuery.trendduration = trendDurationVar();
      // }
      // if (monthVar()) {
      //   newQuery.month = monthVar();
      // }
      // if (yearVar()) {
      //   newQuery.year = yearVar();
      // }
      const newRequest = stringifyUrl({
        url: u.url,
        query: newQuery,
      });
      // console.log("customFetch new request", newRequest);
      return fetch(newRequest, init);
    } else {
      return fetch(request, init);
    }
  },
});

const httpLink = new HttpLink({
  uri: `${SERVER_URI}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(AUTH_TOKEN);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

export const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
      }
    }),
    // requestLink,
    authLink,
    restLink,
    httpLink,
  ]),
  cache,
  // resolvers: { ... },
});
